import type { FC } from 'react';
import React, { useMemo } from 'react';
import { Button } from '@/DesignSystem/Component';
import { WelcomeSubscriptionTab } from '@/Module/Auth/Component';
import { useAppSelector } from '@/Module/Store/Hook';
interface IWelcomeSuggestSubscription {
  setSection: (payload: number) => void;
}
const WelcomeSuggestSubscription: FC<IWelcomeSuggestSubscription> = ({
  setSection
}) => {
  const categoryId = useAppSelector(state => state.auth.parentId);
  const title = useMemo(() => {
    switch (categoryId) {
      case 1:
        return 'دبستان';
      case 2:
        return 'متوسطه اول';
      case 3:
        return 'متوسطه دوم ';
      default:
        return '';
    }
  }, [categoryId]);
  return <div data-sentry-component="WelcomeSuggestSubscription" data-sentry-source-file="WelcomeSuggestSubscription.tsx">
      <div className="flex flex-row justify-center rounded-lg bg-blueTwo px-4 py-2">
        <div className="font-bold text-blueFive">خرید اشتراک</div>
      </div>
      <div className="my-4 text-xl font-extrabold text-blueFive">خرید اشتراک ( {title} )</div>
      <div className="text-blueFive">
        <span className="font-bold">پیشنهاد ویژه</span>
        <span> همین امروز سفر یادگیری خود را شروع کنید و </span>
        <span className="font-bold text-redThree">40٪ تخفیف</span>
        <span className="font-bold"> برای برنامه های سالانه </span>
        <span>دریافت کنید!</span>
        <div>
          این فرصت را برای دسترسی به محتوای آموزشی درجه یک و آماده شدن برای موفقیت از دست ندهید. سریع عمل کنید. این پیشنهاد
          مدت زیادی دوام نخواهد آورد!
        </div>
      </div>
      <WelcomeSubscriptionTab data-sentry-element="WelcomeSubscriptionTab" data-sentry-source-file="WelcomeSuggestSubscription.tsx" />
      <Button bold className="relative mt-4 w-full" variant="shadow" color="primary" radius="circle" size="large" onClick={() => setSection(4)} data-sentry-element="Button" data-sentry-source-file="WelcomeSuggestSubscription.tsx">
        رد کردن این مرحله
      </Button>
    </div>;
};
export default WelcomeSuggestSubscription;